import { createI18n } from 'vue-i18n'
import en from './en'
import de from './de'
import { useI18n } from 'vue-i18n'

export type ILocaleMessage = typeof en
export type SupportedLanguages = 'en' | 'de'
export type ILocale = { message: ILocaleMessage }
export const useTranslation = () => useI18n<ILocale>()

// Create Instance for Localisation
export const i18n = createI18n<[ILocaleMessage], SupportedLanguages>({
  locale: localStorage.getItem('LANG') ?? 'en', // set default locale
  fallbackLocale: 'de', // set fallback locale
  messages: {
    en,
    de,
  }, // set locale messages
  legacy: false,
})
